export const isStaging =
    window.location.hostname === 'app.paybesty.com' ||
    window.location.hostname === 'dev-info.paybesty.com' ||
    process.env.NODE_ENV === 'development';
